import en from 'naughty-words/en.json';
import fi from 'naughty-words/fi.json';

const enShort = en.filter((word) => (word.length <= 6 && word.length > 2));
const fiShort = fi.filter((word) => (word.length <= 6));

const minLength = 5;
const maxLength = 6;
const alphabet = 'abcdefghijklmnopqrstuvwxyz';

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomCharacterFromAlphabet() {
  return alphabet[randomInt(0, alphabet.length - 1)];
}

export default function generateRandomCoupon() {
  var couponLength = randomInt(minLength, maxLength);
  let coupon = '';
  while (coupon.length < couponLength) {
    coupon += randomCharacterFromAlphabet();
  }
  var isBadEnglishWord = enShort.some(v => coupon.indexOf(v) >= 0);
  var isBadFinnishWord = fiShort.some(v => coupon.indexOf(v) >= 0);

  if (!isBadEnglishWord && !isBadFinnishWord) {
    return coupon;
  }
  return generateRandomCoupon();
}



// WEBPACK FOOTER //
// ./src/Offer/RandomCoupon.js